import Banner from 'components/Banner';
import PanelSection from 'components/PanelSection';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const InteractionsSection: FunctionComponent<Props> = ({
    className = '',
    describePair,
    interactions,
    severityToBannerVariant,
    testId = TEST_ID,
    title
}) => (
    <PanelSection
        className={`${styles.interactionsSection} ${className}`}
        testId={testId}
        text={title}>
        {interactions.map(finding => (
            <Banner
                text={describePair(
                    finding.pairNames[0],
                    finding.pairNames[1],
                    finding.interactionType
                )}
                icon='warning'
                key={`${finding.pair[0]}-${finding.pair[1]}-${finding.interactionType}`}
                metadata={finding.description}
                variant={severityToBannerVariant[finding.severity]}
            />
        ))}
    </PanelSection>
);

export default InteractionsSection;
